import { DialogTitle, Stack, Typography } from '@mui/material';
import { Post } from '@vs-online-only-app/state';
import { FC } from 'react';

const PostTitle: FC<Pick<Post, 'title' | 'publishedAt'>> = ({
  title,
  publishedAt,
}) => (
  <DialogTitle>
    <Stack>
      {title}
      {publishedAt && (
        <Typography variant="caption" color="textSecondary">
          {new Date(publishedAt).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })}
        </Typography>
      )}
    </Stack>
  </DialogTitle>
);

export default PostTitle;
